import {
    faAddressBook,
    faBars,
    faBell,
    faBusinessTime,
    faCalendarDays,
    faChartPie,
    faCoins,
    faDashboard,
    faEnvelope,
    faFileInvoiceDollar,
    faFileLines,
    faFolderOpen,
    faGear,
    faLandmark,
    faPowerOff,
    faStickyNote,
    faUsers,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Link, Navigate, Outlet, useLocation } from 'react-router-dom';
import userPhoto from '../../assets/user.jpg';
import { useAuth } from '../../AuthProvider';
import Button from '../../components/Button';
import ButtonVariant from '../../components/ButtonVariant';
import Loader from '../../components/Loader';
import {
    availabilitiesPage,
    billingPage,
    clientsPage,
    contactPage,
    dashboardPage,
    formsPage,
    lawfirmSettingsPage,
    loginPage,
    meetingsPage,
    messagesPage,
    myCasesPage,
    notePage,
    servicesPage,
    settingsPage,
    statisticsPage,
} from '../../constants/pagesRoutesContants';
import { storageItems } from '../../constants/storageItemsContants';
import Role from '../../enums/RoleEnum';
import { classNames } from '../../helpers/classNames';
import NavDataInterface from '../../interfaces/NavDataInterface';
import styles from './style.module.scss';

function Profile() {
    const { isAuth, user, userLogout } = useAuth();
    const { hash, pathname: location } = useLocation();
    const [fullSideNav, setFullSideNav] = useState(false);

    if (!isAuth) {
        if (!loginPage.path.includes(location)) {
            sessionStorage.setItem(storageItems.landingPage, location + hash);
        }
        return <Navigate to={loginPage.path} replace />;
    }

    sessionStorage.removeItem(storageItems.landingPage);

    const handleSideNav = () => {
        setFullSideNav(!fullSideNav);
    };

    const hideSideNav = () => {
        setFullSideNav(false);
    };

    const navDataUser: NavDataInterface[] = [
        {
            id: dashboardPage.path,
            number: 1,
            variant: 'secondaryLight',
            link: dashboardPage.path,
            label: dashboardPage.name,
            icon: faDashboard,
        },
        {
            id: meetingsPage.path,
            number: 7,
            variant: 'secondaryLight',
            link: meetingsPage.path,
            label: meetingsPage.name,
            icon: faCalendarDays,
        },
        {
            id: myCasesPage.path,
            number: 3,
            variant: 'secondaryLight',
            link: myCasesPage.path,
            label: myCasesPage.name,
            icon: faFolderOpen,
        },
        {
            id: messagesPage.path,
            number: 6,
            variant: 'secondaryLight',
            link: messagesPage.path,
            label: messagesPage.name,
            icon: faEnvelope,
        },
        {
            id: contactPage.path,
            number: 6,
            variant: 'secondaryLight',
            link: contactPage.path,
            label: contactPage.name,
            icon: faAddressBook,
        },

        {
            id: settingsPage.path,
            number: 11,
            variant: 'secondaryLight',
            link: settingsPage.path,
            label: settingsPage.name,
            icon: faGear,
        },
    ];

    const navDataLawyer: NavDataInterface[] = [
        ...navDataUser,
        {
            id: formsPage.path,
            number: 4,
            variant: 'secondaryLight',
            link: formsPage.path,
            label: formsPage.name,
            icon: faFileLines,
            //iconColor: 'grey',
        },
        {
            id: clientsPage.path,
            number: 2,
            variant: 'secondaryLight',
            link: clientsPage.path,
            label: clientsPage.name,
            icon: faUsers,
            //iconColor: '#ffbc20',
        },
        {
            id: notePage.path,
            number: 8,
            variant: 'secondaryLight',
            link: notePage.path,
            label: notePage.name,
            icon: faStickyNote,
            //iconColor: 'yellow',
        },
        {
            id: availabilitiesPage.path,
            number: 9,
            variant: 'secondaryLight',
            link: availabilitiesPage.path,
            label: availabilitiesPage.name,
            icon: faBusinessTime,
            //iconColor: '#582900',
        },
        {
            id: servicesPage.path,
            number: 10,
            variant: 'secondaryLight',
            link: servicesPage.path,
            label: servicesPage.name,
            icon: faCoins,
            //iconColor: '#ffd700',
        },
        {
            id: statisticsPage.path,
            number: 11,
            variant: 'secondaryLight',
            link: statisticsPage.path,
            label: statisticsPage.name,
            icon: faChartPie,
            //iconColor: 'black',
        },
        {
            id: billingPage.path,
            number: 12,
            variant: 'secondaryLight',
            link: billingPage.path,
            label: billingPage.name,
            icon: faFileInvoiceDollar,
            //iconColor: 'white',
        },
        {
            id: lawfirmSettingsPage.path,
            number: 13,
            variant: 'secondaryLight',
            link: lawfirmSettingsPage.path,
            label: lawfirmSettingsPage.name,
            icon: faLandmark,
            //iconColor: 'gray',
        },
    ];

    const navData: NavDataInterface[] =
        user?.role === Role.Lawyer
            ? navDataLawyer.sort((a, b) => {
                  if (a.number && b.number) {
                      return a.number - b.number;
                  }
                  return 0;
              })
            : navDataUser;

    if (!user) {
        <Loader />;
    }

    return (
        <div className={styles.body}>
            <div className={styles.container}>
                <div
                    className={classNames([
                        styles.sideNavContainer,
                        fullSideNav ? styles.collapsed : '',
                    ])}
                >
                    <div className={classNames([styles.logoContainer])}>
                        <img
                            src={'/logo-192x192.png'}
                            alt="Liber'All Logo"
                            className={styles.logoImage}
                        />
                        <span className={styles.title}>
                            <Link to="/">Liber'all</Link>
                        </span>
                        <span className={styles.collapsedSideNav}>
                            <ButtonVariant
                                variant="tertiary"
                                onClick={handleSideNav}
                            >
                                <FontAwesomeIcon icon={faBars} />
                            </ButtonVariant>
                        </span>
                    </div>
                    <div className={styles.userContainer}>
                        <div className={styles.photoContainer}>
                            <img
                                src={user?.photo || userPhoto}
                                alt={(
                                    user?.firstName +
                                    '_' +
                                    user?.lastName
                                ).replace(' ', '_')}
                                className={styles.photoCard}
                            />
                        </div>
                        <div className={styles.identity}>
                            <div className={styles.nameContainer}>
                                {user?.firstName}{' '}
                                {user?.lastName?.toLocaleUpperCase()}
                            </div>
                            <div className={styles.btn}>
                                <Button
                                    variant="primaryLight"
                                    onClick={userLogout}
                                >
                                    <FontAwesomeIcon icon={faPowerOff} />
                                    <span>Se deconnecter</span>
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className={styles.linksContainer}>
                        {navData?.map((item) => (
                            <div
                                className={classNames([
                                    styles.sideNavBtn,
                                    location.includes(item.id) &&
                                    location.length > 0
                                        ? styles.selected
                                        : '',
                                ])}
                                key={item.label + '_' + item.id}
                            >
                                <ButtonVariant
                                    variant={item.variant}
                                    link={item.link}
                                    key={item.id || item.label}
                                    onClick={hideSideNav}
                                >
                                    {item.icon && (
                                        <FontAwesomeIcon icon={item.icon} />
                                    )}
                                    <label className={styles.label}>
                                        {item.label}
                                    </label>
                                </ButtonVariant>
                            </div>
                        ))}
                    </div>
                </div>
                <div
                    className={classNames([
                        styles.mainContainer,
                        fullSideNav ? styles.collapsed : '',
                    ])}
                >
                    <div className={styles.navbar}>
                        <div className={styles.navbarContainer}>
                            <div className={styles.notification}>
                                <ButtonVariant variant="tertiary">
                                    <FontAwesomeIcon icon={faBell} />
                                </ButtonVariant>
                            </div>
                        </div>
                    </div>
                    <div className={styles.pagesContainer}>
                        <div className={styles.pagesBody}>
                            <Outlet context={user} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Profile;
